import React, { useState } from "react";
import PropTypes from "prop-types";
import Avatar from "@shared/v2/Avatar";
import IconButton from "@shared/v2/IconButton";
import { PencilSolidV6, TrashSolidV6, XmarkSolidV6 } from "@shared/v2/Icomoon";
import Button from "@shared/v2/Button";
import Dropdown from "@shared/v2/Dropdown";

const EditAddRelationship = ({
  person,
  relationship,
  relationshipOptions,
  saveRelationship,
  deleteRelationship,
}) => {
  const [label, setLabel] = useState(relationship.related_person_label);
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div className="tw-flex-1 tw-flex tw-items-center tw-gap-[16px] tw-overflow-hidden tw-px-[20px] tw-py-[8px] hover:tw-bg-tinted-gray-25 tw-group">
      <a
        className={`${isEditing ? "" : "tw-flex-1"} tw-flex tw-items-center tw-gap-[16px] tw-overflow-hidden hover:tw-no-underline active:tw-no-underline`}
        href={relationship.related_person_url}
      >
        <Avatar
          size="medium"
          src={relationship.related_person_avatar_url}
          alt={relationship.related_person_name}
        />
        {!isEditing && (
          <div className="tw-flex tw-flex-col tw-overflow-hidden">
            <span className="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-text-14d tw-text-gray-75 tw-font-semibold">
              {relationship.related_person_name}
            </span>
            <span className="tw-text-11d tw-text-gray-75 tw-font-bold tw-uppercase">
              {relationship.related_person_label === "Unspecified" ? " " : relationship.related_person_label}
            </span>
          </div>
        )}
      </a>

      {isEditing && (
        <Dropdown
          containerClassName="tw-grow"
          menuShouldComeToFront
          isSearchable
          isClearable={false}
          options={relationshipOptions}
          onChange={(option) => {
            if (option) setLabel(option.value);
          }}
          value={relationshipOptions.find((o) => o.value === label) || null}
        />
      )}

      {isEditing ? (
        <div className="tw-flex tw-flex-col tw-gap-[4px]">
          <Button
            onClick={() => {
              saveRelationship(person.data.attributes, relationship.id, null, label);
              setIsEditing(false);
            }}
          >
            Save
          </Button>
          <div className="tw-flex tw-gap-[8px]">
            <IconButton
              size="small"
              schema="tertiary"
              onClick={() => {
                deleteRelationship(person.data.attributes, relationship.id);
                setIsEditing(false);
              }}
            >
              <TrashSolidV6 />
            </IconButton>
            <IconButton size="small" schema="tertiary" onClick={() => setIsEditing(false)}>
              <XmarkSolidV6 />
            </IconButton>
          </div>
        </div>
      ) : (
        <IconButton
          className="tw-flex-none tw-invisible group-hover:tw-visible"
          size="small"
          schema="tertiary"
          onClick={() => setIsEditing(true)}
        >
          <PencilSolidV6 />
        </IconButton>
      )}
    </div>
  );
};

EditAddRelationship.propTypes = {
  person: PropTypes.shape().isRequired,
  relationship: PropTypes.shape().isRequired,
  relationshipOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  saveRelationship: PropTypes.func.isRequired,
  deleteRelationship: PropTypes.func.isRequired,
};

export default EditAddRelationship;
